import React from 'react';

const StackedCircularProgressBar = ({ segments, total, displayText = true, displayTextToOverride }) => {
  const radius = 90;
  const strokeWidth = 20;
  const circumference = 2 * Math.PI * radius;
  let accumulatedPercentage = 0;
  return (
    <div>
      <svg width="200" height="200" viewBox="0 0 200 200">
        {/* Background Circle */}
        <circle
          cx="100"
          cy="100"
          r={radius}
          fill="transparent"
          stroke="#eee"
          strokeWidth={strokeWidth}/>
        {/* Dynamic Segments */}
        {segments.map(({ value, color }, index) => {
          const percentage = (value / total) * 100;
          const strokeDashoffset = circumference - (percentage / 100) * circumference;
          const rotation = (accumulatedPercentage / 100) * 360 - 90;
          accumulatedPercentage += percentage;
          return (
            <circle
              key={index}
              cx="100"
              cy="100"
              r={radius}
              fill="transparent"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="butt"
              transform={`rotate(${rotation} 100 100)`}
            />
          );
        })}
        {/* Center Text */}
        {displayText && (
          <text
            x="50%"
            y="50%"
            dominantBaseline="middle"
            textAnchor="middle"
            fontSize="20"
            fontWeight="bold">
            {/* Sum of all segments */}
            {
              displayTextToOverride 
              ? displayTextToOverride 
              :  `${segments.reduce((sum, { value }) => sum + value, 0)}`
            }
          </text>
        )}
      </svg>
    </div>
  );
};

export default StackedCircularProgressBar;
